import { render, staticRenderFns } from "./externalKetenagaan.vue?vue&type=template&id=564f86e3"
import script from "./externalKetenagaan.vue?vue&type=script&lang=js"
export * from "./externalKetenagaan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564f86e3')) {
      api.createRecord('564f86e3', component.options)
    } else {
      api.reload('564f86e3', component.options)
    }
    module.hot.accept("./externalKetenagaan.vue?vue&type=template&id=564f86e3", function () {
      api.rerender('564f86e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/external/pelayanan/externalKetenagaan.vue"
export default component.exports